import type { Placement } from '@popperjs/core';
import classNames from 'classnames';
import React from 'react';
import type { ReferenceChildrenProps } from 'react-popper';
import isSize from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';
import PopOver from './deprecated/PopOver';
import styles from './Tooltip.module.scss';

type TriggerType = 'click' | 'hover' | null;

interface PopOverProps {
  arrow?: Element;
  children:
    | ((props: ReferenceChildrenProps) => React.ReactNode)
    | React.ReactNode;
  disablePersist?: boolean;
  display?: 'block' | 'inline-block' | 'inline';
  longHoverDelay?: boolean;
  modifiers?: unknown[];
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
  placement: Placement;
  popOver?: () => React.ReactNode | React.ReactNode;
  popOverPortal?: Element;
  preventCloseOnContentClick?: boolean;
  responsivePlacement?: 'top' | 'bottom';
  trigger?: TriggerType;
}

interface TooltipProps extends PopOverProps {
  tooltip?: React.ReactNode;
  trigger?: TriggerType;
  enabledForSmallSize?: boolean;
}

const Tooltip = ({
  display = 'inline-block',
  tooltip = null,
  trigger = undefined,
  enabledForSmallSize = false,
  ...props
}: TooltipProps) => {
  const isMobile = isSize(Sizes.SM);

  let actualTrigger = trigger;
  if (isMobile && trigger === 'hover' && enabledForSmallSize) {
    actualTrigger = 'click';
  }

  return (
    <PopOver
      // @ts-expect-error
      display={display}
      trigger={actualTrigger}
      popOver={
        !!tooltip &&
        // Binding hover event on touch devices introduces side effect
        // that the element requires double-tap to trigger click event.
        !(isMobile && actualTrigger === 'hover') &&
        // @ts-expect-error
        // eslint-disable-next-line react/no-unstable-nested-components -- Fix next time editing the file
        (({ arrowProps, placement }) => (
          <div
            className={classNames(styles.tooltip, {
              [styles[placement]]: placement,
            })}
          >
            <div className={styles.inner}>
              {tooltip}
              <div className={styles.arrow} {...arrowProps} />
            </div>
          </div>
        ))
      }
      {...props}
    />
  );
};

export default Tooltip;
